<template>
	<div>
		<div class="msg_box flex_sp">
			<aside class="pras_left">
				<!-- 一级分类 -->
				<p class="pras_title">产品分类</p>
				<div v-for="(itme) in classifyList" :key="itme.id+'D'">
					<span :class="{'a_dase':className==itme.id}"
					@click="clickClass(itme.id)">{{itme.title}}</span>
				</div>
			</aside>
				<article v-if="isval"  class="box_aqa">
					<h3>很抱歉，您查看的产品找不到了！</h3>
					<div class="aqa_zi">
						<p>您可以:</p>
						<div>1.检查刚才的输入</div>
						<div>2.去其他地方逛逛：<span class="lan" @click="xin.goUrl('/index')">首页</span></div>
					</div>
				</article>
			<main v-else v-loading="loading" class="pras_right">
				<nav class="arrow_box clearfloat">
					<span class="arrow_ywz">您的位置：</span>
					<div class="arrow">
						<span class="to" @click="xin.goUrl('/index')">首页</span>
						<span class="el-icon-arrow-right"></span>
						<span class="to" @click="xin.goUrl('/product')">产品中心</span>
						<span class="el-icon-arrow-right"></span>
						<span class="topc">{{category.title}}</span>
					</div>
				</nav>
				<header>
					<p class="tech_title">{{category.title}}</p>
					<div class="ruel">
						{{category.intr}}
					</div>
				</header>
				<!-- 二级分类标签 -->
				<nav class="one_vessel">
					<div class="laing_btn" :class="{'btn_one':tabid!=item.id}" @click="setGoods(item.id)"
					 v-for="(item) in category.category" :key="item.id+'S'">{{item.title}}</div>
				</nav>
				<!-- 产品列表 -->
				<section>
					<table class="table" v-loading="loading2" v-if="goodsList.length" cellpadding="0px" >
						<thead bgcolor="#F2F2F2" >
							<th>品名</th>
							<th>货号</th>
							<!-- <th>规格</th>
							<th>价格(元)</th> -->
							<th>用途</th>
						</thead>
						<tbody>
							<tr v-for="item in goodsList" :key="item.id+'V'">
								<td class="fonta" @click="xin.goUrl('/products/'+item.id)">
									<span class="xiahuanxa">
										{{item.title}}
									</span>
								</td>
								<td class="fonta" @click="xin.goUrl('/products/'+item.id)">
									<span class="xiahuanxa">
										{{item.model}}
									</span>
								</td>
								<!-- <td>{{item.attr_value}}</td>
								<td>￥{{item.sale_price}}</td> -->
								<td>{{item.use}}</td>
							</tr>
						</tbody>
					</table>
				</section>
				<!-- 二级分类详情 -->
				<section class="magtop60" v-html="category.details"></section>
			</main>
		</div>
	</div>
</template>

<script>
	import {
		mapState,mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
				loading2:true,
				loading:true,
				isval:false,
				category_2:0,//二级分类ID
				category:{},//分类详情
				tabid:0,//二级标签索引
				goodsList:[],//产品列表
			}
		},
		computed: {
			...mapState(['classifyList','className'])
		},
		created() {
			// this.setclassName(this.$route.query.cid);
			this.PostproductInfo(this.$route.query.cid);
		},
		watch:{
			$route(to,fo){
				this.PostproductInfo(to.query.cid);
			}
		},
		methods: {
			...mapMutations(['setclassName','setactiveIndex']),
			async PostproductInfo(category_id){//获取一级分类详情
				if(!category_id){
					this.isval=true;
					return;
				}else this.isval=false;
				this.loading = true;
				let {data} = await this.api.PostproductInfo({category_id});
				this.category = data;
				this.isval =data.category?false:true;
				if(data.category){
					let id = (data.category[0]||{}).id;
					let c2id = this.$route.query.c2id||id;
					this.tabid = c2id;
					if(c2id)
						this.PostproductList(c2id);
				}else this.goodsList =[];
				this.loading = false;
			},
			async PostproductList(category_id){//获取产品列表
				this.loading2 = true;
				let {data} = await this.api.PostproductList({category_id});
				this.goodsList = data||[];
				this.loading2 = false;
			},
			setGoods(id){
				// let index = this.category.category.findIndex(v => v.id == id);
				this.tabid = id;
				this.PostproductList(id);
			},
			clickClass(val){
				this.goodsList = [];
				this.xin.goUrl('/oneDetails?cid='+val);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.table{
		width: 100%;
		color: #333333;
		margin-top: 50px;
		td,th{
			padding: 10px;
		}
		td{
			text-align: center;
			border: 0.5px solid #D9D9D9;
		}
	}
	.pras_left {
		box-sizing: border-box;
		color: #666666;
		font-size: 18px;
		width: 300px;
    	padding-right: 10px;
		div {
			line-height: 36px;
		}
		span {
			cursor: pointer;
		}
		.pras_title {
			font-size: 26px;
			font-weight: 500;
			color: #333333;
		}
	}
	.pras_right{
		width: 900px;
		.image_big{
			width: 900px;
			img{
				width: 100%;
			}
		}
		.one_vessel{
			box-sizing: border-box;
			margin-top: 30px;
			display: flex;
			// justify-content: space-between;
			flex-wrap: wrap;
			.btn_one{
				background: #fff;
				color: #666;
				border: 1px solid #666;
			}
			div{
				margin: 5px 0 0 5px;
				width: 173px;
				height: 50px;
				line-height: 50px;
				border-radius: 0px;
				box-sizing: border-box;
			}
		}
	}
</style>
